import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-metrics';
import { trans } from '@spotahome/soyuz/client';

import { getSortingOptions, getHiddenSortingConfig } from '../utils/sorting';

import './SortBy.scss';

const DEFAULT_OPTIONS = getSortingOptions();

class SortBy extends PureComponent {
  static propTypes = {
    handleSortByChange: PropTypes.func.isRequired,
    orderBy: PropTypes.string.isRequired
  };

  handleChange = e => {
    Metrics.ga.sendEvent('Search', 'sort-by', e.target.value);
    this.props.handleSortByChange(e.target.value);
  };

  render() {
    const hiddenFilterSort = getHiddenSortingConfig(this.props.orderBy);
    const options = [
      ...DEFAULT_OPTIONS.map(option => (
        <option value={option.value} key={option.key}>
          {trans('search.filter_header.sort_by')}: {trans(option.key)}
        </option>
      )),
      ...(hiddenFilterSort
        ? [
            <option value={hiddenFilterSort.value} key={hiddenFilterSort.value}>
              {trans('search.filter_header.sort_by')}:{' '}
              {trans(hiddenFilterSort.key)}
            </option>
          ]
        : [])
    ];
    return (
      <div className="sort-by">
        <select
          className="sort-by__select"
          onChange={this.handleChange}
          value={this.props.orderBy}
        >
          {options}
        </select>
      </div>
    );
  }
}

export default SortBy;
